import src from "IMAGE";
export default { src, width: 1322, height: 213, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AHZ1dohKSUlVZWVldW9vb4BtbW19dnZ2iWJiYnJmZWZ126gNefoD7EsAAAAASUVORK5CYII="};
